export default __webpack_public_path__ + "static/media/product04.1280b750.png";